module.exports = __webpack_public_path__ + "a4187bc04c137613fecea265611f65a4.png";


//////////////////
// WEBPACK FOOTER
// ../images/sponsors/microsoft.png
// module id = 411
// module chunks = 0